(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Hide-on-scroll-down, reveal-on-scroll-up — mobile/tablet only (<960px).
    // Accumulator pattern ignores trackpad jitter while still triggering on slow scrolls.
    (function () {
      const headerEl = document.querySelector('.site-header');
      if (!headerEl) return;
      const headerDrawer = document.querySelector('.site-header__drawer');
      const headerSearch = document.getElementById('site-search');
      const mq = window.matchMedia('(max-width: 959px)');

      let lastY = window.scrollY;
      let ticking = false;
      let accum = 0;
      let lastDir = 0;
      const DELTA = 5;

      function update() {
        const currentY = window.scrollY;
        const diff = currentY - lastY;
        const dir = diff > 0 ? 1 : (diff < 0 ? -1 : 0);
        const hideAfter = headerEl.offsetHeight;

        if (dir !== 0) {
          accum = (dir === lastDir) ? accum + Math.abs(diff) : Math.abs(diff);
          lastDir = dir;
        }

        const drawerOpen = headerDrawer && headerDrawer.open;
        const searchOpen = headerSearch && headerSearch.open;

        if (!mq.matches || drawerOpen || searchOpen || currentY < hideAfter) {
          headerEl.classList.remove('is-hidden');
        } else if (dir === 1 && accum >= DELTA) {
          headerEl.classList.add('is-hidden');
        } else if (dir === -1 && accum >= DELTA) {
          headerEl.classList.remove('is-hidden');
        }

        lastY = currentY;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', function () {
          if (!mq.matches) headerEl.classList.remove('is-hidden');
        });
      }

      if (headerDrawer) {
        headerDrawer.addEventListener('toggle', function () {
          if (headerDrawer.open) headerEl.classList.remove('is-hidden');
        });
      }
    })();

    const dialog = document.getElementById('site-search');
    if (!dialog) return;

    const openTriggers = document.querySelectorAll('.js-search-open');
    const closeBtn = dialog.querySelector('.js-search-close');
    const backdrop = dialog.querySelector('.site-search__backdrop');
    const form = dialog.querySelector('[data-search-form]');
    const input = dialog.querySelector('[data-search-input]');
    const clearBtn = dialog.querySelector('[data-search-clear]');
    const resultsEl = dialog.querySelector('[data-search-results]');
    const statusEl = dialog.querySelector('[data-search-status]');

    let activeRequest = null;
    let debounceTimer = null;

    function openSearch() {
      if (typeof dialog.showModal === 'function') {
        try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
      } else {
        dialog.setAttribute('open', '');
      }
      openTriggers.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { input && input.focus(); }, 60);
    }

    function closeSearch() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeSearch();
    });

    dialog.addEventListener('close', function () {
      openTriggers.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const tag = (e.target.tagName || '').toLowerCase();
        const isEditable = tag === 'input' || tag === 'textarea' || e.target.isContentEditable;
        if (isEditable) return;
        e.preventDefault();
        openSearch();
      }
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        openSearch();
      }
    });

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function showStatus(html) {
      statusEl.innerHTML = html;
      statusEl.hidden = false;
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
    }

    function showResults(html) {
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      statusEl.hidden = true;
    }

    function renderResults(data, q) {
      const r = (data.resources && data.resources.results) || {};
      const products = r.products || [];
      const collections = r.collections || [];
      const articles = r.articles || [];
      const pages = r.pages || [];

      const total = products.length + collections.length + articles.length + pages.length;
      if (total === 0) {
        showStatus('<p class="site-search__empty">No results for that. Try a broader term, or browse the <a href="/collections/all">full pantry</a>.</p>');
        return;
      }

      let html = '';

      if (products.length) {
        html += '<div class="site-search__group"><h3 class="site-search__group-title">Pantry</h3><ul class="site-search__list site-search__product-list" role="list">';
        products.forEach(function (p) {
          const img = p.featured_image && p.featured_image.url
            ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="' + escapeHtml(p.featured_image.alt || p.title) + '" loading="lazy">'
            : '';
          const price = p.price ? '<span class="site-search__result-meta">' + escapeHtml(p.price) + '</span>' : '';
          html += '<li><a class="site-search__result" href="' + escapeHtml(p.url) + '">' +
                  '<span class="site-search__result-media">' + img + '</span>' +
                  '<span class="site-search__result-body">' +
                    '<span class="site-search__result-title">' + escapeHtml(p.title) + '</span>' +
                    price +
                  '</span>' +
                  '</a></li>';
        });
        html += '</ul></div>';
      }

      function plainGroup(label, items) {
        if (!items.length) return '';
        let h = '<div class="site-search__group"><h3 class="site-search__group-title">' + label + '</h3><ul class="site-search__list" role="list">';
        items.forEach(function (it) {
          h += '<li><a class="site-search__result-plain" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.title) + '</a></li>';
        });
        h += '</ul></div>';
        return h;
      }

      html += plainGroup('Collections', collections);
      html += plainGroup('Journal', articles);
      html += plainGroup('Pages', pages);

      html += '<a class="site-search__view-all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';

      showResults(html);
    }

    async function runQuery(q) {
      if (activeRequest && activeRequest.abort) {
        try { activeRequest.abort(); } catch (e) {}
      }
      const controller = new AbortController();
      activeRequest = controller;

      showStatus('<div class="site-search__loading"><span class="site-search__loading-spinner" aria-hidden="true"></span> Searching</div>');

      try {
        const params = new URLSearchParams({
          'q': q,
          'resources[type]': 'product,collection,article,page',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
        });
        const res = await fetch('/search/suggest.json?' + params.toString(), {
          signal: controller.signal,
          headers: { 'Accept': 'application/json' },
        });
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        renderResults(data, q);
      } catch (err) {
        if (err.name === 'AbortError') return;
        showStatus('<p class="site-search__empty">Something went wrong. Please try again.</p>');
      } finally {
        if (activeRequest === controller) activeRequest = null;
      }
    }

    function onInput() {
      const q = (input.value || '').trim();
      clearBtn.hidden = q.length === 0;
      clearTimeout(debounceTimer);

      if (q.length === 0) {
        showStatus('<p class="site-search__hint">Try \'fusilli\', \'biscotti\', or \'gift basket\'.</p>');
        return;
      }
      if (q.length < 2) {
        showStatus('<p class="site-search__hint">Keep typing.</p>');
        return;
      }

      debounceTimer = setTimeout(function () { runQuery(q); }, 160);
    }

    if (input) input.addEventListener('input', onInput);

    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      onInput();
    });

    input && input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
